import React, { useState } from "react";
import ButtonComponent from "components/FormsComponents/ButtonComponent";
import { getStorageData } from "utils/helper";
import { Form, Modal } from "react-bootstrap";
import { DOMAIN_CLINKS } from "constants/app";
import { agencyEmailSend } from "apiServices/app";
import TextBoxComponent from "components/FormsComponents/TextBoxComponent";
import { FaPaperPlane } from "react-icons/fa";
import SelectComponent from "components/FormsComponents/SelectComponent";
import { title } from "process";

const AddReviewsModalComponent = ({ showModal, setShowModal }) => {
  const domain = getStorageData("domain");
  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState();

  const handleClose = () => {
    setShowModal(false);
  };
  const [formData, setFormData] = useState({
    domain_status: domain === DOMAIN_CLINKS ? true : false,
  });

  const handleInput = ({ target: { name, value } }) => {
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors({ ...errors, [name]: "" });
  };
  const handleStore = () => {
    console.log("formData new", formData);

    // setLoader(true);
    // agencyEmailSend(formData)
    //   .then(({ data, success }) => {
    //     if (success === "true") {
    //       setShowModal(false);
    //       setShowSuccess(true); // Show success modal
    //     }
    //   })
    //   .catch((err) => {
    //     const {
    //       error: { error = {} },
    //     } = err;
    //     if (Object.entries(error).length !== 0) {
    //       setErrors({ ...errors, email: error.email[0] });
    //     }
    //   })
    //   .finally(() => {
    //     setLoader(false);
    //   });
  };

  return (
    <>
      <Modal backdrop="static" show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Leave a review</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div className="p-2">
              <label>Your Name</label>
              <TextBoxComponent
                name="name"
                label="Your Name"
                type="name"
                value={formData && formData.name}
                title="Your Name"
                handleInput={handleInput}
                placeholder="Enter your name"
                errors={errors && errors.name}
                className="lg rounded-pill"
              />
            </div>
            <div className="p-2">
              <label>Your Email</label>
              <TextBoxComponent
                name="email"
                label="Your Email"
                type="text"
                value={formData && formData.email}
                title="Your Email"
                handleInput={handleInput}
                placeholder="Enter your email"
                errors={errors && errors.email}
                className="lg rounded-pill"
              />
            </div>
            <div className="p-2">
              <SelectComponent
                name="ratting"
                options={[
                  {
                    label: "1",
                    value: "1",
                  },
                  {
                    label: "2",
                    value: "2",
                  },
                  {
                    label: "3",
                    value: "3",
                  },
                ]}
                label="ratting"
                value={formData && formData.ratting}
                title="Ratting"
                handleInput={handleInput}
                placeholder="select ratting"
                errors={errors && errors.ratting}
                className="rounded-pill"
              />
            </div>
            <div className="p-2">
              <label>Review</label>
              <Form.Control
                as="textarea"
                rows={3}
                name="review"
                value={formData && formData.review}
                cols="50"
                placeholder="Write a review..."
              />
              {errors && errors.review && (
                <span className="text-danger">{errors.review}</span>
              )}
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-center gap-2">
            <ButtonComponent variant="secondary" onClick={handleClose} title="Close">
              Close
            </ButtonComponent>
            <ButtonComponent variant="primary" onClick={handleStore} title="Submit Review">
              Submit Review
            </ButtonComponent>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddReviewsModalComponent;
